<template>
	<a href="#" aria-role="button" v-bind:tabindex="tabindex" v-text="title" v-on:click.stop.prevent="followLink" @keyup.enter="followLink" v-bind:class="['button', {'active':active}]"></a>
</template>

<script>
import TextLink from './TextLink'
export default {
	extends: TextLink
}
</script>